import VueI18n from 'vue-i18n';
import frFR from '../translations/fr_FR.json';
import enUS from '../translations/en_US.json';
import frCA from '../translations/fr_CA.json';
const messages = {
    'en-US': enUS,
    'fr-FR': frFR,
    'fr-CA': frCA,
};
class i18nService {
    init() {
        const selectedLang = localStorage.getItem('lang');
        return new VueI18n({
            fallbackRoot: 'fr-FR',
            fallbackLocale: 'fr-FR',
            locale: selectedLang || 'fr-FR',
            messages,
            numberFormats: messages,
        });
    }
    setLangTo($root, lang) {
        localStorage.setItem('lang', lang);
        return ($root.$i18n.locale = lang);
    }
}
export default new i18nService();
